<template>
  <div class="app-container">
    <el-card shadow="never">
      <!-- header -->
      <!-- <div slot="header">
        <span>'管理员-广告主管理'</span>
      </div> -->
      <div>
        <div class="filter-container">
          <div class="searchContainer">
            <label for="searchword">管理员名称：</label>
            <!-- 搜索框 -->
            <el-autocomplete
              v-model="adminAdvertiserListQuery.user_name"
              class="inline-input"
              :fetch-suggestions="adminQuerySearch"
              placeholder="请输入内容"
              @select="adminSelect"
            />
          </div>
          <div class="searchContainer">
            <label for="searchword">广告主名称：</label>
            <!-- 搜索框 -->
            <el-autocomplete
              v-model="adminAdvertiserListQuery.advertiser_name"
              class="inline-input"
              :fetch-suggestions="advertQuerySearch"
              placeholder="请输入内容"
              @select="advertiserSelect"
            />
          </div>
          <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >
            搜索
          </el-button>
          <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-refresh"
            @click="handleFilterReset"
          >
            重置
          </el-button>
          <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate"
          >
            添加账号
          </el-button>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="adminAdvertData.list"
        highlight-current-row
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        class="border-gray"
        fit
        header-align="center"
        style="width: 100%; justify-content: space-between;"
      >
        <el-table-column
          prop="user_name"
          label="管理员名称"
          width="380"
        >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.user_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="account_name"
          label="广告主名称"
        >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.account_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="110"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="open(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      title="添加账号"
      :visible.sync="addAccount.flag"
      width="500px"
    >
      <admin-advert-add
        :advertiser="adminAdvertData.advertiser"
        :user="adminAdvertData.user"
        @submit="submitForm(arguments)"
      />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import AdminAdvertAdd from './components/AdminAdvertAdd.vue'
import { bindAdminAdvert, deleAdminAdvert, getList } from '@/api/adminAdvertMangement.js'
export default {
  name: 'AdminAdvertMangement',
  components: {
    PaginationRight,
    AdminAdvertAdd
  },
  data() {
    return {
      // 请求相关
      total: 0,
      // 绑定弹窗显示开关
      addAccount: {
        flag: false
      },
      // 列表数据
      adminAdvertData: {},
      // 搜索下拉列表名称
      advertNameList: [],
      adminNameList: [],
      // 用于存储搜索框输入值
      adminAdvertiserListQuery: {
        user_name: null,
        advertiser_name: null,
        page: 1,
        page_size: 10
      },
      // search: {
      //   AdminSearchText: '',
      //   AdvertSearchText: '',
      //   getPageTotalDataFlag: true
      // },
      adminSearchList: '',
      loading: false // 加载动画
    }
  },
  // watch: {
  //   search: {
  //     handler(newName, oldName) {
  //       console.log(newName, oldName)
  //     },
  //     immediate: true,
  //     deep: true
  //   }
  // },
  created() {
    // this.getAdminAdvertList()
    this.getAdminAdvertiserList()
  },
  methods: {
    // handleAdd(index, row) {
    //   console.log(index, row)
    // },

    // 抓取分页数据
    fetchPageSize(data) {
      this.adminAdvertiserListQuery.pageSize = data
      // getList(this.search.AdminSearchText, this.search.AdvertSearchText, this.query.page, this.query.pageSize).then(res => {
      //   this.adminSearchList = res.data.list
      //   this.adminAdvertData = res.data
      //   console.log(res.data.list)
      // })
      this.getAdminAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.adminAdvertiserListQuery.page = data
      // getList(this.search.AdminSearchText, this.search.AdvertSearchText, this.query.page, this.query.pageSize).then(res => {
      //   this.adminSearchList = res.data.list
      //   this.adminAdvertData = res.data
      //   console.log(res.data.list)
      // })
      this.getAdminAdvertiserList()
    },
    // 搜索
    handleFilter() {
      this.adminAdvertiserListQuery.page = 1
      this.getAdminAdvertiserList()
      // this.$message({
      //   type: 'success',
      //   message: '搜索成功'
      // })
      // getList(this.search.AdminSearchText, this.search.AdvertSearchText).then(res => {
      //   console.log(res)
      //   this.adminAdvertData = res.data
      //   this.adminSearchList = res.data.list
      //   this.query.total = res.data.count
      //   this.$message({
      //     type: 'success',
      //     message: '搜索成功'
      //   })
      // })
    },
    // 重置搜索框
    handleFilterReset() {
      this.adminAdvertiserListQuery = {}
      this.getAdminAdvertiserList()
      // this.search.AdminSearchText = ''
      // this.search.AdvertSearchText = ''
      // getList().then(res => {
      //   console.log(res)
      //   this.adminAdvertData = res.data
      //   this.adminSearchList = res.data.list
      //   this.query.total = res.data.count
      //   this.$message({
      //     type: 'success',
      //     message: '重置成功'
      //   })
      // })
    },
    // 添加账号
    handleCreate() {
      this.addAccount.flag = true
    },
    // 提交添加绑定
    submitForm(msg) {
      const addQuery = {}
      addQuery.admin_id = msg[0]
      addQuery.advertiser_id = msg[1]
      bindAdminAdvert(addQuery).then(res => {
        this.getAdminAdvertiserList()
        this.$message({
          type: 'success',
          message: '添加成功!'
        })
      })
      this.addAccount.flag = false
    },
    // getAdminAdvertList() {
    //   getList(this.search.AdminSearchText, this.search.AdvertSearchText).then(res => {
    //     this.adminAdvertData = res.data
    //     this.adminSearchList = res.data.list
    //     this.query.total = res.data.count
    //   })
    // },
    // 获取管理员和广告组列表
    getAdminAdvertiserList() {
      this.loading = true
      getList(this.adminAdvertiserListQuery).then(res => {
        this.adminAdvertData = res.data
        this.adminSearchList = res.data.list
        this.total = res.data.count
        this.loading = false
      })
    },
    open(index, row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 解除管理员和广告主的绑定
        deleAdminAdvert(row.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getAdminAdvertiserList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    adminQuerySearch(queryString, cb) {
      const adminSearchList = this.adminSearchList
      // const filterResult = []
      const obj = {}
      for (var i = 0; i < adminSearchList.length; i++) {
        obj[adminSearchList[i].user_name] = 1 // 除去重复名称
      }
      // 初始化容器数组，不然会每次触发都会无限增加
      this.adminNameList = []
      // 把去重的对象属性重新放到数组中
      for (i in obj) {
        const str = {}
        str.value = i
        this.adminNameList[this.adminNameList.length] = str
      }
      // console.log(filterResult)
      const results = queryString ? this.adminNameList.filter(this.createFilter(queryString)) : this.adminNameList
      cb(results)
    },
    advertQuerySearch(queryString, cb) {
      const adminSearchList = this.adminSearchList
      for (var i = 0; i < adminSearchList.length; i++) {
        const obj = {}
        obj.value = adminSearchList[i].account_name
        this.advertNameList[i] = obj
      }
      const results = queryString ? this.advertNameList.filter(this.createFilter(queryString)) : this.advertNameList
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    adminSelect(select) {
      this.search.AdminSearchText = select.value
    },
    advertiserSelect(select) {
      this.search.AdvertSearchText = select.account_name
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-table th > .cell {
  padding-left: 21px;
}
/deep/ .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
}
</style>
